export default __webpack_public_path__ + "static/media/zkEVM.fa179cde.svg";